<template>
    <div class="register-page">
        <div class="register-box">
            <div class="card">
                <div class="card-body register-card-body">
                    <p class="login-box-msg">Edit Profile</p>

                    <errors :success="success" :failure="failure" :message="message" :loading="loading" />
                    <!-- <form method="post" ref="form"> -->
                        <div class="input-group">
                            <input type="text" class="form-control" v-model="name" placeholder="Full name" required>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <span class="fas fa-user"></span>
                                </div>
                            </div>
                        </div>
                        <p class="small text-danger mb-3" v-html="errors.name"></p>

                        <div class="input-group">
                            <input type="email" class="form-control" v-model="email" placeholder="Email" disabled>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <span class="fas fa-envelope"></span>
                                </div>
                            </div>
                        </div>
                        <p class="small text-danger mb-3" v-html="errors.email"></p>

                        <!-- <div class="input-group">
                            <input class="form-control" v-model="username" placeholder="Username" disabled>
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <span class="fa fa-user"></span>
                                </div>
                            </div>
                        </div>
                        <p class="small text-danger mb-3" v-html="errors.username"></p> -->

                        <div class="input-group">
                            <input type="password" class="form-control" v-model="password" placeholder="New Password" >
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <span class="fas fa-unlock"></span>
                                </div>
                            </div>
                        </div>
                        <p class="small text-danger mb-3" v-html="errors.password"></p>

                        <div class="input-group">
                            <input type="password" class="form-control" v-model="password_confirmation" placeholder="Confirm password" >
                            <div class="input-group-append">
                                <div class="input-group-text">
                                <span class="fas fa-unlock"></span>
                                </div>
                            </div>

                        </div>
                        <p class="small text-danger mb-3" v-html="errors.password_confirmation"></p>

                        <div class="row">
                            <div class="col-12">
                                <button type="button" class="btn btn-primary btn-block" @click="saveupdate($event)">Update Profile</button>
                            </div>
                            <!-- /.col -->
                        </div>
                    <!-- </form> -->


                </div>
                <!-- /.form-box -->
            </div><!-- /.card -->

        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Errors from '../partials/Errors.vue'
import Swal from 'sweetalert2';

export default {
    components: { Errors },
    name: "ProfileEdit",
    data() {
        return {
            name: '',
            email: '',
            username: '',
            password: '',
            password_confirmation: '',
            success: false,
            failure: false,
            message: '',
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                name: '',
                email: '',
                username: '',
                password: '',
                password_confirmation: ''
            },
            userdata: '',
        }
    },
    props: {
        user:'',
    },
    mounted() {
        this.userdata = JSON.parse(this.user);
        this.setUserData();
    },
    methods: {
        setUserData(){
            this.name = this.userdata.name;
            this.email = this.userdata.email;
            this.username = this.userdata.email;
        },
        validateInput(element='all'){
            if(this.name == '' || this.name.length <6) { this.errors.name = "Full Name should be longer than 6 letters"; console.error("Name < 6 chars");return false;}
            if (this.password == '' || this.password.length<8) {this.errors.password = "Password length should be >= 8 characters"; console.error('Password lengths <8'); return false;}
            if(this.password != this.password_confirmation) {this.errors.password = "Password inputs don't match";   console.error("Password inputs don't match");return false;}
            return true;
        },
        saveupdate(event) {
            if(!this.validateInput()) return;
            this.saveupdateReal(event);
        },
        saveupdateReal(event) {
            event.preventDefault()
            // Show the loading alert
            this.loading = true
            this.failure = false
            this.success = false

            // Register the user
            let user = {
                user_id: this.userdata.id,
                name: this.name,
                email: this.email,
                // username: this.username,
                password: this.password,
                password_confirmation: this.password_confirmation,
                _token: this.token
            }
            // Empty the errors
            this.errors.name = null
            this.errors.email = null
            this.errors.username = null
            this.errors.password = null
            axios.post('/profile/update', user)
            .then(res => {
                this.loading = false
                this.success = true
                this.message = "Successfully Updated Profile."
                this.failure = false
                this.updateToast('Your changes have been saved successfully');
                setTimeout(() => {
                    window.location.href = '/home'
                }, 1000)
            })
            .catch(err => {
                this.loading = false
                this.failure = true
                // Show the error message
                this.message = err.response.data.message
                this.errors.name = err.response.data.errors.name ? err.response.data.errors.name[0] : null
                this.errors.email = err.response.data.errors.email ? err.response.data.errors.email[0] : null
                this.errors.username = err.response.data.errors.username ? err.response.data.errors.username[0] : null
                this.errors.password = err.response.data.errors.password ? err.response.data.errors.password[0] : null
                this.success = false;
                this.updateToast('Your changes could not be saved at this time. Apologies');
            })
        },
        updateToast(message, timer = 3000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
    }
}
</script>
